'use client';

import { Product } from 'shared/types/product/Product';
import { DataSource } from 'types/datasource';
import { TasticProps } from 'frontastic/tastics/types';
import YouMayAlsoLikeSlider, { YouMayAlsoLikeSliderProps } from 'components/commercetools-ui/organisms/youMayAlsoLike';

function YouMayAlsoLikeSliderTastic({
  data,
}: TasticProps<DataSource<{ items: Product[] }> & YouMayAlsoLikeSliderProps>) {
  if (!data?.data?.dataSource?.items) return <></>;

  //eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { mobile, tablet, desktop, ...props } = data;
  const retrievedVariants =
    typeof window !== 'undefined' ? JSON.parse(localStorage.getItem('RecentlyViewed') || '[]') : [];
  const sortedDataSource = data?.data?.dataSource?.items?.sort((a, b) => {
    const brandA = a?.variants?.[0]?.attributes?.brand;
    const brandB = b?.variants?.[0]?.attributes?.brand;

    if (
      brandA === retrievedVariants?.[0]?.variants?.[0]?.attributes?.brand &&
      brandB !== retrievedVariants?.[0]?.variants?.[0]?.attributes?.brand
    ) {
      return -1;
    } else if (
      brandB === retrievedVariants?.[0]?.variants?.[0]?.attributes?.brand &&
      brandA !== retrievedVariants?.[0]?.variants?.[0]?.attributes?.brand
    ) {
      return 1;
    }

    return 0;
  });

  return <YouMayAlsoLikeSlider {...props} products={sortedDataSource} productLogo={data.productLogo} />;
}

export default YouMayAlsoLikeSliderTastic;
